class EventManager {
    #_listeners;
    #_store;

    constructor(getStore) {
        this.#_listeners = {};
        this.#_store = getStore;
    }

    watchStore(watcher, callback) {
        const self = this;
        const store = self.#_store();
        store.watch(watcher, (newVal, oldVal) => {
            callback(store, newVal, oldVal);
        })
    }

    trigger(event, data) {
        if (this.#_listeners[event]) {
            this.#_listeners[event].forEach(cb => {
                cb(event, data);
            })
        }
    }

    addListener(event, callback) {
        if (!this.#_listeners[event])
            this.#_listeners[event] = [];

        this.#_listeners[event] = callback;

        return this;
    }

    removeListener(event, selector) {
        const eventListeners = this.#_listeners[event];
        let indexOfListener = eventListeners.findIndex(l => l.callback === selector);
        eventListeners.splice(indexOfListener, 1);
    }
}


export default EventManager;
